/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import '../../assets/styles/manualHeightGalleryWrapper.scss';
import { isHeightByContentGallery } from '../../utils/gallery';
export const WixProGalleryWithManualHeightGalleryWrapper = WixProGallery => props => {
  const renderGallery = () => /*#__PURE__*/React.createElement(WixProGallery, props);
  return props.positionAbsoluteForFiniteHeightGalleries && !isHeightByContentGallery(props.options) ? /*#__PURE__*/React.createElement("div", {
    className: 'manual-height-gallery-wrapper'
  }, renderGallery()) : renderGallery();
};
//# sourceMappingURL=withManualHeightGalleryWrapper.js.map